import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import AuthCallback from "@/pages/AuthCallback";
import { Shell } from "@/components/layout/Shell";
import Home from "@/pages/Home";
import ThumbnailDownloader from "@/pages/ThumbnailDownloader";
import TagExtractor from "@/pages/TagExtractor";
import EarningsCalculator from "@/pages/EarningsCalculator";
import HashtagGenerator from "@/pages/HashtagGenerator";
import ChannelFinder from "@/pages/ChannelFinder";
import TrendingTags from "@/pages/TrendingTags";
import AiTitles from "@/pages/AiTitles";
import AiIdeas from "@/pages/AiIdeas";
import Dashboard from "@/pages/Dashboard";
import CalendarScripts from "@/pages/CalendarScripts";
import ScriptEditor from "@/pages/ScriptEditor";
import IdeaBoard from "@/pages/IdeaBoard";
import MediaLibrary from "@/pages/MediaLibrary";
import SubtitleExtractor from "@/pages/SubtitleExtractor";
import ThumbnailPreview from "@/pages/ThumbnailPreview";
import TitleChecker from "@/pages/TitleChecker";
import ChapterFormatter from "@/pages/ChapterFormatter";
import ReadingTimer from "@/pages/ReadingTimer";
import VideoReviews from "@/pages/VideoReviews";
import ReviewWorkspace from "@/pages/ReviewWorkspace";
import Contact from "@/pages/Contact";
import AdminInbox from "@/pages/AdminInbox";
import Teleprompter from "@/pages/Teleprompter";
import Studio from "@/pages/Studio";
import DescriptionGenerator from "@/pages/DescriptionGenerator";
import ChannelIdConverter from "@/pages/ChannelIdConverter";

const TOAST_OPTIONS = { style: { background: "var(--card)", color: "var(--text)", border: "1px solid var(--border-c)" } };

function AppRouter() {
  const location = useLocation();
  // Read hash from useLocation (reactive) — detects OAuth callback before routes render
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Shell />}>
        <Route path="/" element={<Home />} />
        <Route path="/tools/subtitle-extractor" element={<SubtitleExtractor />} />
        <Route path="/tools/thumbnail-downloader" element={<ThumbnailDownloader />} />
        <Route path="/tools/tag-extractor" element={<TagExtractor />} />
        <Route path="/tools/earnings-calculator" element={<EarningsCalculator />} />
        <Route path="/tools/hashtag-generator" element={<HashtagGenerator />} />
        <Route path="/tools/channel-finder" element={<ChannelFinder />} />
        <Route path="/tools/trending-tags" element={<TrendingTags />} />
        <Route path="/tools/ai-titles" element={<AiTitles />} />
        <Route path="/tools/ai-ideas" element={<AiIdeas />} />
        <Route path="/tools/thumbnail-preview" element={<ThumbnailPreview />} />
        <Route path="/tools/title-checker" element={<TitleChecker />} />
        <Route path="/tools/chapter-formatter" element={<ChapterFormatter />} />
        <Route path="/tools/reading-timer" element={<ReadingTimer />} />
        <Route path="/tools/thumbnail-studio" element={<Studio />} />
        <Route path="/studio" element={<Studio />} />
        <Route path="/tools/description-generator" element={<DescriptionGenerator />} />
        <Route path="/tools/channel-id-converter" element={<ChannelIdConverter />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/calendar" element={<CalendarScripts />} />
        <Route path="/ideas" element={<IdeaBoard />} />
        <Route path="/media" element={<MediaLibrary />} />
        <Route path="/reviews" element={<VideoReviews />} />
        <Route path="/reviews/:id" element={<ReviewWorkspace />} />
        <Route path="/review/share/:token" element={<ReviewWorkspace shared />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin/inbox" element={<AdminInbox />} />
        <Route path="/scripts/:id" element={<ScriptEditor />} />
        <Route path="/teleprompter/:id" element={<Teleprompter />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="bottom-right" toastOptions={TOAST_OPTIONS} />
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
